import type {
  ClassifierDtos,
  ServiceLevelDefinitionDto,
} from 'redux/services/generate/configurations/serviceLevelDefinitions';
import {
  fromBitEnumValue,
  fromNoYesEnum,
  type ServiceLevelFormValues,
} from '../serviceLevelOptions';

export const mapServiceLevelToFormValues = (
  serviceLevel: ServiceLevelDefinitionDto,
  classifiers: ClassifierDtos | undefined,
): ServiceLevelFormValues => ({
  serviceLevelName: serviceLevel.serviceLevelName,
  documentServices: fromBitEnumValue(
    Number(serviceLevel.documentServices),
    classifiers?.documentServices,
  ),
  languages: fromBitEnumValue(
    Number(serviceLevel.languages),
    classifiers?.languages,
  ),
  draftStandards: fromNoYesEnum(serviceLevel.draftStandards),
  redline: fromNoYesEnum(serviceLevel.redline),
  previousVersions: Number(serviceLevel.previousVersions),
  multiLanguage: serviceLevel.multiLanguage,
  subscriptionType: serviceLevel.subscriptionLicenseType ?? 0,
  allowedNsbIds: serviceLevel.allowedNsbIds,
  updateExistingSubscriptions: false,
  isServiceLevelPriceFactorEnabled:
    serviceLevel.priceFactor !== null && serviceLevel.priceFactor !== undefined,
  priceFactor: serviceLevel.priceFactor ?? undefined,
});
